import { render, staticRenderFns } from "./project-com.vue?vue&type=template&id=197a9350&scoped=true"
import script from "./project-com.vue?vue&type=script&lang=js"
export * from "./project-com.vue?vue&type=script&lang=js"
import style0 from "./project-com.vue?vue&type=style&index=0&id=197a9350&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a9350",
  null
  
)

export default component.exports